<!--恒岳读书会-->
<template>
    <div class="event-nav-container">
        <div class="museum-title-container" v-show="showMode==='page'">
            <div class="l-museum-title-container">
                <div class="l-t-museum-title-container">行•知行合一</div>
                <div class="l-b-museum-title-container">自然研学实践 户外主题班会 生态体验活动</div>
            </div>
            <div class="r-museum-title-container">
                <div  class="back-btn-container" @click="backReadMuseum" >⇦返回</div>
            </div>
        </div>
        <div class="event-content-container" v-show="showMode==='page'">
            <div class="event-content-top-container">
                <div class="event-item-container" v-for="item in itemList.slice(0,1)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg1">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(1,2)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg2">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(2,3)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg3">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(3,4)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg4">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(4,5)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg5">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(5,6)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg6">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
            </div>
            <div class="event-content-bottom-container">
                <div class="event-item-container" v-for="item in itemList.slice(6,7)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg7">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(7,8)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg8">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(8,9)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg9">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(9,10)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg10">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(10,11)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg11">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
                <div class="event-item-container" v-for="item in itemList.slice(11,12)" :key="item" @click="pageMyjr(item)">
                    <div class="event-item fygf-bg12">
                        <div class="event-title" style="margin-top: 10px;">{{item.itemDesc}}</div>
                        <div class="event-desc"></div>
                    </div>
                </div>
            </div>
        </div>

        <!--自然研学活动列表-->
        <div class="nature-content-container" v-show="showMode==='list'">
            <museum-activity-page :item-info="currentItem"
                                museum-key="5"
                                :mark-info="subMarkInfo"
                                @back-page="backToPage"
                                @view-info="viewActivityInfo"/>
        </div>

        <!--自然研学活动详情-->
        <div class="nature-content-container" v-show="showMode==='info'">
            <museum-activity-info :activity-id="activityId"
                                :mark-info="subMarkInfo"
                                @back-page="backToList"/>
        </div>
    </div>
</template>
<script>
import {listItem} from "@/api/admin/museum"
import museumActivityPage from "@/components/museumEvent/museumActivityPage.vue";
import museumActivityInfo from "@/components/museumEvent/museumActivityInfo.vue";

export default {
    name:'natureEventClub',
    components:{museumActivityPage, museumActivityInfo},
    props:{
        museumId:{
            type: String,
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch:{
        museumId(newValue,oldValue){
            this.showMode = 'page';
            this.queryItemList();
        },
        markInfo(newValue,oldValue){
            this.showMode = 'page';
            this.queryItemList();
        },
    },
    mounted() {
    },
    created() {
        this.queryItemList();
    },
    data() {
        return {
            showMode:'page',
            itemList:[],
            currentItem:{},
            activityId:'',
            subMarkInfo:'',
            queryItemForm:{
                itemType:'6',
                museumKey:'5',
            },
        }
    },
    methods: {
        queryItemList(){
            listItem(this.queryItemForm).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data || [];
                }else {
                    this.$message.error(res.data.msg || "请求出错")
                }
            })
        },
        /*查看主题线下活动列表*/
        pageMyjr(item){
            this.currentItem = item;
            this.subMarkInfo = new Date() + '';
            this.showMode = 'list';
        },
        /*查看线下活动详情*/
        viewActivityInfo(item){
            this.activityId = item.activityId;
            this.subMarkInfo = new Date() + '';
            this.showMode = 'info';
        },
        backToPage(){
            this.showMode = 'page';
        },
        backToList(){
            this.showMode = 'list';
        },
        backReadMuseum(){
            this.showMode = 'page';
            this.$emit('back-read-museum', "homePage");
        },
    }
}
</script>
<style>
.event-nav-container{
    width: 100%;
    height: calc(100vh - 90px);
    background: rgba(255,255,255,.5);
    border-radius: 28px;

}
.museum-title-container{
    width: 100%;
    height: 70px;
    display: flex;
    padding: 0 30px 0 30px!important;
    box-sizing: border-box;
}
.l-museum-title-container{
    width: calc(100% - 80px);
    height: 70px;
}
.l-t-museum-title-container{
    width: 100%;
    height: 40px;
    font-weight: bold;
    color: #0d55a4;
    font-size: 17px;
    line-height: 50px;
}
.l-b-museum-title-container{
    width: 100%;
    height: 30px;
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.back-btn-container{
    width: 80px;
    height: 32px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 15px;
    border-radius: 6px;
    letter-spacing: 3px;
    cursor: pointer;
}

.event-content-container{
    width: 100%;
    height: calc(100% - 70px);
    padding: 10px 20px 20px 20px;
    box-sizing: border-box;
}
.event-content-top-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-item-container{
    width: 16.6%;
    height: 100%;
    display: flex;
    border: 10px;
    box-sizing: border-box;
}
.event-item{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.fygf-bg1{
    background-image: url("../../assets/zxhy/zxhy_1.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg2{
    background-image: url("../../assets/zxhy/zxhy_2.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg3{
    background-image: url("../../assets/zxhy/zxhy_3.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg4{
    background-image: url("../../assets/zxhy/zxhy_4.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg5{
    background-image: url("../../assets/zxhy/zxhy_5.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg6{
    background-image: url("../../assets/zxhy/zxhy_6.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg7{
    background-image: url("../../assets/zxhy/zxhy_7.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg8{
    background-image: url("../../assets/zxhy/zxhy_8.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg9{
    background-image: url("../../assets/zxhy/zxhy_9.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg10{
    background-image: url("../../assets/zxhy/zxhy_10.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg11{
    background-image: url("../../assets/zxhy/zxhy_11.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.fygf-bg12{
    background-image: url("../../assets/zxhy/zxhy_12.png");
    background-size: 100% 100%!important;
    background-repeat: no-repeat!important;
}
.event-content-bottom-container{
    width: 100%;
    height: 50%;
    display: flex;
    gap: 10px;
}
.event-title{
    width: 100%;
    height: 50px;
    line-height: 60px;
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    color: #0d55a4;
}
.event-desc{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    color: #9a9a9a;
}
.nature-content-container{
    width: 100%;
    height: 100%;
}
</style>